import { useContext } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { BassContext } from "../contexts/bass-context";
import { KeyContext } from "../contexts/key-context";
import { getAvailableBassNotes } from "../utils/chord-lookup";

const BassDropdown = () => {
  const { bassValue, dispatch } = useContext(BassContext);
  const { keyValue } = useContext(KeyContext);

  const bassDropdownValues = getAvailableBassNotes(keyValue);

  return (
    <Dropdown>
      <Dropdown.Toggle className="glass-btn">
        {bassValue === "No Bass" ? "Bass" : bassValue}
      </Dropdown.Toggle>
      <Dropdown.Menu className="scrollable-menu">
        {bassDropdownValues.map((value) => {
          return (
            <Dropdown.Item
              as="button"
              key={value}
              value={value}
              onClick={() => {
                dispatch({ type: "BASS", bassValue: value });
              }}
            >
              {value}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default BassDropdown;
